import { useWebTranslation } from "translations";
import styles from "./QuotePreviewNotice.module.css";
import { Typography } from "ui-kit/Typography";
import { Icon } from "ui-kit";
import Colors from "ui-kit/colors";

export const QuotePreviewNotice = () => {
  const { t } = useWebTranslation();

  return (
    <div className={styles.container}>
      <div>
        <Icon
          name="information-circle-fill"
          color={Colors.blue300}
          size="S"
          ariaHidden
        />
      </div>
      <Typography variant="body3">{t("signup.chip_number_notice")}</Typography>
    </div>
  );
};
